import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-agreement-banner',
  templateUrl: './agreement-banner.component.html'
})
export class AgreementBannerComponent {
  @Input() days: number;
  @Input() link: string;

  bannerAgreementToString = $localize`:@@agreement-banner.bannerAgreementTo:to Amadeus.`;
  bannerAgreementSecondString = $localize`:@@agreement-banner.bannerAgreementSecond:days</strong>. Please <strong>print, sign</strong> and <strong>send</strong>`;
  bannerAgreementFirstString = $localize`:@@agreement-banner.bannerAgreementFirst:You have access to the <strong>full version</strong> of Amadeus Direct for <strong>`;
}
